import React from "react";
import Header from "../../layout/header/AppTopNav";
import Footer from "../../layout/footer/footer1";
import Skeleton from "../ui/Skeleton";

/**
 * Pantalla de carga de la HOME (Tanda 5.7 · P01 con 4 escenarios).
 *
 * Refleja la estructura genérica que la home nueva usa en TODOS los estados
 * (greeting + una card grande + grid de 4 tarjetas) para no saltar el layout
 * cuando llegan los datos. NO intenta distinguir nuevo/acceso/recurrente:
 * un solo shape sirve a los tres — la home real luego decide qué pinta.
 *
 * Accesibilidad: `aria-busy` en el contenedor y `aria-hidden` en el esqueleto
 * (un lector de pantalla no anuncia esto como contenido).
 */
const HomeSkeleton = ({ t }) => (
  <>
    <Header />

    <main className="page-content bg-white home-page" aria-busy="true">
      <div
        aria-hidden="true"
        data-testid="home-skeleton"
        className="mx-auto"
        style={{ maxWidth: 1160, padding: "20px 16px 120px" }}
      >
        {/* Greeting: dos líneas (subtítulo + título) */}
        <div style={{ marginBottom: 26 }} data-testid="home-skeleton-greeting">
          <Skeleton
            width={140}
            height={16}
            style={{ display: "block", marginBottom: 10 }}
          />
          <Skeleton
            width="65%"
            height={30}
            style={{ display: "block" }}
          />
        </div>

        {/* Card grande (featured / continue / recommended) */}
        <div
          data-testid="home-skeleton-hero"
          style={{
            background: "var(--color-surface)",
            border: "1px solid var(--color-line)",
            borderRadius: 18,
            overflow: "hidden",
            marginBottom: 30,
          }}
        >
          <Skeleton width="100%" height={236} radius={0} />
          <div style={{ padding: "16px 16px 18px" }}>
            <Skeleton
              width="70%"
              height={22}
              style={{ display: "block", marginBottom: 10 }}
            />
            <Skeleton
              width="40%"
              height={14}
              style={{ display: "block", marginBottom: 14 }}
            />
            <Skeleton width="100%" height={56} radius={12} style={{ display: "block" }} />
          </div>
        </div>

        {/* Grid de 4 tarjetas (En progreso o catálogo) */}
        <Skeleton
          width={180}
          height={20}
          style={{ display: "block", marginBottom: 12 }}
        />
        <div
          data-testid="home-skeleton-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
            gap: 16,
            marginBottom: 30,
          }}
        >
          {[0, 1, 2, 3].map((i) => (
            <div
              key={i}
              style={{
                background: "var(--color-surface)",
                border: "1px solid var(--color-line)",
                borderRadius: 16,
                overflow: "hidden",
              }}
              data-testid="home-skeleton-card"
            >
              <Skeleton width="100%" height={140} radius={0} />
              <div style={{ padding: "15px 16px 16px" }}>
                <Skeleton
                  width="80%"
                  height={18}
                  style={{ display: "block", marginBottom: 12 }}
                />
                <Skeleton width="100%" height={48} radius={11} style={{ display: "block" }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </main>

    <Footer t={t} />
  </>
);

export default HomeSkeleton;
